// Angular Imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// This Module's Components
import { EggSelectionLookupComponent } from './egg-selection-lookup.component';
import { BizDatatableModule } from '../biz-datatable/biz-datatable.module';
import { PagesContainersModule } from '../../../../../containers/pages/pages.containers.module';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule, CommonModule, BizDatatableModule, PagesContainersModule
    ],
    declarations: [
        EggSelectionLookupComponent,
    ],
    exports: [
        EggSelectionLookupComponent,
    ]
})
export class EggSelectionLookupModule {

}
